<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card>
          <v-card-text>
            <p class="text-h2 text--primary font-weight-thin">
              Concours
            </p>
            <v-divider />
            <br>
            <span class="text-h3">
              Edition {{ edition }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-text>
            <p class="text-h2 text--primary font-weight-thin">
              Participants
            </p>
            <v-divider />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    components: {
    },
    data: () => ({
    }),
    computed: {
      edition: get('artifex/config.edition.edition'),
    },
    methods: {

    },
  }
</script>
